import { AuthEndpoint } from './Auth';
function attachmentDateToIso(value) {
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (typeof value === 'string' && value.length > 0) {
        const d = new Date(value);
        if (!Number.isNaN(d.getTime())) {
            return d.toISOString();
        }
    }
    return value;
}
function mapAttachmentRequestBody(body) {
    if (body == null || typeof body !== 'object' || body instanceof FormData) {
        return body;
    }
    const b = body;
    return {
        ...b,
        ...(b.startDate != null && b.startDate !== ''
            ? { startDate: attachmentDateToIso(b.startDate) }
            : {}),
        ...(b.endDate != null && b.endDate !== ''
            ? { endDate: attachmentDateToIso(b.endDate) }
            : {})
    };
}
/** Normalizes bulk-list date fields to ISO-8601 for the API. */
export class AttachmentEndpoint extends AuthEndpoint {
    async getRequestInit(body) {
        return super.getRequestInit(mapAttachmentRequestBody(body));
    }
}
